import { CommonModule } from '@angular/common';
import {
  Component,
  ChangeDetectionStrategy,
  ViewEncapsulation,
  ChangeDetectorRef,
  inject,
  OnInit,
  DestroyRef,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { MobileNavigationComponent } from '../../common/components/mobile-navigation/mobile-navigation.component';
import { SeoService } from '../../services/meta.service';
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import { emailValidator } from '../../common/validators/form.validator';
import { TicketsService } from '../../services/tickets.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ToastrService } from 'ngx-toastr';
import { RfpService } from '../../services/rfp.service';
@Component({
  selector: 'app-rfp',
  templateUrl: './rfp.component.html',
  styleUrls: ['./rfp.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    MobileNavigationComponent,
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RfpComponent implements OnInit {
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly seoService = inject(SeoService);
  private readonly rfpService = inject(RfpService);
  private readonly toastr = inject(ToastrService);
  public destroyRef = inject(DestroyRef);

  public form = new UntypedFormGroup({
    email: new UntypedFormControl(null, [Validators.required, emailValidator]),
    fullName: new UntypedFormControl(null, [Validators.required]),
    projectName: new UntypedFormControl(null, [Validators.required]),
    pdfFile: new UntypedFormControl(null, [Validators.required]),
  });

  public loading = false;
  ngOnInit(): void {
    this.seoService.setMetaTags({
      title: 'Wire Festival | Info',
      description: 'Wire Festival Info',
      keywords: 'Wire Festival Info',
    });
  }
  onImageLoad(event: Event) {
    const img = event.target as HTMLImageElement;
    img.classList.add('loaded');
    this.cdr.detectChanges();
  }
  onImageError(event: Event) {
    const img = event.target as HTMLImageElement;
    img.classList.add('error');
    this.cdr.detectChanges();
  }

  handleFileSelect(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];

    if (!file) return;

    const validTypes = ['application/pdf'];
    if (!validTypes.includes(file.type)) {
      this.toastr.error('Invalid file type. Please upload PDF.');
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      this.toastr.error('File size exceeds 5MB limit.');
      return;
    }
    this.form.get('pdfFile')?.setValue(file);
  }

  checkTickets() {
    this.loading = true;
    this.cdr.detectChanges();

    this.loading = true;
    this.rfpService
      .rfpSubmission({
        email: this.form.value.email,
        fullName: this.form.value.fullName,
        projectName: this.form.value.projectName,
        file: this.form.value.pdfFile,
      })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (response: any) => {
          this.loading = false;
          this.toastr.success('RFP submission successful');
          this.cdr.detectChanges();
          this.form.reset();
        },
        error: (error) => {
          this.loading = false;
          this.toastr.error(error.error.message);
          this.cdr.detectChanges();
        },
      });
  }
}
